<template>
    <div class="doc_make">
        <el-form :model="makeForm" :rules="rules" ref="makeForm" label-width="180px" label-position="left" class="make-ruleForm" :disabled="isClosed">
            <el-form-item label="模式选择" prop="makeModel">
                <el-radio-group v-model="makeForm.makeModel" @change="checkoutModel">
                    <el-radio label="1">调解模式</el-radio>
                    <el-radio label="2">撤诉模式</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="调解时间" prop="dates" v-if="makeForm.makeModel==1" style="margin-bottom: 50px">
                <el-date-picker
                        v-model="makeForm.dates"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="调解条件" prop="remark" v-if="makeForm.makeModel==1">
                <el-input v-model="makeForm.remark" type="textarea" :rows="10" maxlength="2000" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="撤诉理由" prop="reason" v-if="makeForm.makeModel==2">
                <el-radio-group v-model="makeForm.reason">
                    <el-radio label="个人原因">个人原因</el-radio>
                    <el-radio label="双方协商一致">双方协商一致</el-radio>
                </el-radio-group>
<!--                <el-input v-model="makeForm.reason" type="textarea" :rows="10" maxlength="2000" show-word-limit></el-input>-->
            </el-form-item>
            <el-form-item label="" prop="templateType" v-if="makeForm.makeModel==1">
                <el-radio-group v-model="makeForm.templateType">
                    <el-radio label="0">仲裁员版</el-radio>
                    <el-radio label="1">三方调解版</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div style="text-align: center">
            <el-button class="btn" :disabled="isClosed || isManage" :loading="BtnLoading" type="primary" @click="previewDocument">自动生成</el-button>
        </div>
        <el-dialog class="doc_make_dialog" title="自动生成" width="60%" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" center>
            <div class="doc_make_wrap">
                <div style="display: flex; justify-content: space-between">
                    <el-menu :default-active="menuIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#0083c8">
                        <el-menu-item v-for="(item, index) in fileList" :index="index.toString()" :key="index">{{item.docName}}</el-menu-item>
                    </el-menu>
                </div>
                <iframe class="doc_make_frame" v-if="clerkRecordPdfUrl" :src="clerkRecordPdfUrl"></iframe>
            </div>
            <div slot="footer" class="dialog-footer">
                <div style="width: 100%; margin-bottom: 20px; text-align: left">
                    <div style="font-size: 14px; color: #0083c8">发送签字人员</div>
                    <div style="display: flex; margin-top: 10px">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChanged" style="margin-right: 30px">全选</el-checkbox>
                        <el-checkbox-group v-model="sendUserList" @change="handleSendArrChanged">
                            <el-checkbox v-for="(item, index) in confirmList" :key="index" :label="item.userId" name="type">{{item.userName}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div>
                    <el-button @click="goBack">返回</el-button>
                    <el-button type="primary" :loading="BtnLoading" @click="sendBook">提交发送</el-button>
                    <el-button type="primary" @click="downLoad">下载word版本</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import filedownload from '@/api/filedown.js'
    import {generateDoc, createDocxMediation, sendDoc, getUserSingnatureAndEmail} from "../../../api/casespace";
    import {checkSpecialChar, isManageRole} from "../../../utils/utils";
    import {getStore} from "../../../utils/utils";

    export default {
        name: "",
        data() {
            return {
                menuIndex: null,
                curRoomId: null,
                clerkRecordPdfUrl: null,
                confirmList: [],
                sendUserList: [],
                isIndeterminate: false,
                checkAll: false,
                makeForm: {
                    makeModel: '1',
                    templateType: '0',
                    dates: [],
                    remark: '',
                    reason: '',
                },
                rules: {
                    dates: [
                        {required: true, message: '请选择调解时间', trigger: 'change'}
                    ],
                    remark: [
                        {required: true, message: '请输入调解条件', trigger: 'blur'},
                        {required: true, validator: checkSpecialChar, trigger: 'blur'}
                    ]
                },
                BtnLoading: false,
                dialogVisible: false,
                isManage: false,
                isClosed: localStorage.getItem('CloseState') == 'true' ? true : false,
                fileList: []
            }
        },
        components: {},
        watch: {
            menuIndex (newValue, oldValue) {
                if (newValue) {
                    let index = Number(newValue)
                    this.clerkRecordPdfUrl = this.fileList[index].clerkRecordPdfUrl
                } else {
                    this.clerkRecordPdfUrl = null
                }
            }
        },
        created() {
            this.curRoomId = this.$route.query.meetingid
        },
        mounted() {
            let loginInfouser = JSON.parse(getStore('loginInfo'));
            this.isManage = isManageRole(loginInfouser.userRoles)
            if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
                this.getUsersSign()
            }
        },
        methods: {
            checkoutModel() {
                if (this.makeForm.makeModel == 1) {
                    this.rules = {
                        dates: [{
                            required: true,
                            message: '请选择调解时间',
                            trigger: 'change'
                        }],
                            remark: [
                                {required: true, message: '请输入调解条件', trigger: 'blur'},
                                {required: true, validator: checkSpecialChar, trigger: 'blur'}
                            ]
                    }
                } else {
                    this.rules = {
                        reason: [
                            {required: true, message: '请选择撤诉理由', trigger: 'change'},
                            {required: true, validator: checkSpecialChar, trigger: 'blur'}
                        ]
                    }
                }
                this.$refs.makeForm.clearValidate()
            },
            previewDocument() {
                this.$refs.makeForm.validate((valid) => {
                    if (valid) {
                        this.BtnLoading = true
                        if (this.makeForm.makeModel == 2) {
                            generateDoc({
                                meetingId: Number(this.$route.query.meetingid),
                                reason: this.makeForm.reason,
                            }).then(res => {
                                if (res.data.code === 1000) {
                                    this.fileList = res.data.data
                                    this.menuIndex = '0'
                                    this.dialogVisible = true
                                } else {
                                    this.$message.error(res.data.message)
                                }
                                this.BtnLoading = false
                            }).catch(error => {
                                this.BtnLoading = false
                            })
                        } else {
                            createDocxMediation({
                                meetingId: Number(this.$route.query.meetingid),
                                caseId: Number(this.$route.query.caseid),   // 案件id
                                startTime: this.makeForm.dates[0],    // 调解开始时间
                                endTime: this.makeForm.dates[1],   // 调解结束时间
                                mediationConditions: this.makeForm.remark,   // 调解条件
                                templateType: Number(this.makeForm.templateType)
                            }).then(res => {
                                if (res.data.code === 1000) {
                                    this.fileList = res.data.data
                                    this.menuIndex = '0'
                                    this.dialogVisible = true
                                } else {
                                    this.$message.error(res.data.message)
                                }
                                this.BtnLoading = false
                            }).catch(error => {
                                this.BtnLoading = false
                            })
                        }
                    }
                })
            },
            handleSelect(key, keyPath) {
                this.menuIndex = key
                console.log(key, keyPath);
                // fileList[menuIndex].
            },
            //获取用户签名接口
            getUsersSign() {
                getUserSingnatureAndEmail({
                    objectId: this.curRoomId
                }).then((res) => {
                    if (res.data.code == 1000) {
                        this.confirmList = res.data.data
                    }
                })
            },
            handleCheckAllChanged(val) {
                this.sendUserList = []
                if (val) {
                    this.confirmList.forEach(item => {
                        this.sendUserList.push(item.userId)
                    })
                }
                this.isIndeterminate = false;
            },
            handleSendArrChanged(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.confirmList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.confirmList.length;
            },
            downLoad() {
                this.fileList.forEach(doc => {
                    window.open(doc.clerkRecordDownloadUrl)
                    // filedownload('/gzzc/docBook/clerkRecordDownload', {
                    //     fileId: doc.fileId,
                    //     id: doc.docId
                    // }, doc.fileName)
                })
            },
            sendBook() {
                if (!this.sendUserList || this.sendUserList.length == 0) {
                    this.$message.warning('请选择发送签字人员')
                    return
                }
                this.BtnLoading = true
                let docList = []
                this.fileList.forEach(item => {
                    docList.push({
                        docId: item.docId,
                        docName: item.docName,
                        docType: item.docType,
                        documentId: item.documentId,
                        fileId: item.fileId,
                        fileName: item.fileName
                    })
                })
                let param = {
                    meetingId: Number(this.$route.query.meetingid),
                    userIdList: this.sendUserList,
                    docList: docList
                }
                sendDoc(param, this.makeForm.makeModel=='1'? 'mediation':'backout').then(res => {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.goBack()
                        this.$message.success('操作成功')
                        this.$emit('changeTab', {index: '2', activeName: 'seventh'})
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            goBack() {
                this.menuIndex = null
                this.dialogVisible = false
            }
        }
    }
</script>

<style lang="scss" scoped>
.doc_make {
    /*margin: 0 auto;*/
    margin-left: 5%;
    width: 1000px;
    .make-ruleForm {
        margin: 26px 40px 20px 20px;
        /deep/ .el-form-item {
            margin-bottom: 40px;
        }
        /deep/ .el-form-item__label {
            font-size: 20px;
            color: #333333;
            position: relative;
            padding-left: 12px;
            &:before {
                position: absolute;
                content: '';
                width: 4px;
                height: 20px;
                background-color: #1e6dcb;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        /deep/ .el-form-item__content {
            width: 800px;
        }
    }
}
.doc_make_dialog {
    /deep/ .el-dialog {
        margin-top: 60px !important;
        height: calc(100vh - 120px);
    }
    /deep/ .el-dialog__body {
        padding-bottom: 0;
        overflow-y: scroll;
        height: calc(100% - 224px);
    }
    /deep/ .el-dialog__footer {
        padding-top: 16px;
    }
    .doc_make_wrap {
        width: 100%;
        .doc_make_frame {
            height: 600px;
            width: 100%;
        }
    }
    .dialog-footer {

    }
}
</style>
